<template>
	<div>
		<Breadcrumb></Breadcrumb>
		<el-row :gutter="20" type="flex">
		      <el-col :span="24">
		        <el-card class="mt-2">
		          <h4 class="fs_18 font-weight-semibold m-0 text-000 mb-3">门店信息</h4>
		          <div class="w-100 d-flex align-items-center flex-wrap">
					  <el-divider content-position="left">基本信息</el-divider>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									门店名称：
								</div>
								<div class="flex-1">
									{{data.name || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									联系人：
								</div>
								<div class="flex-1">
									{{data.username || ''}}
								</div>
							 </div>
						  </el-col>
					  </el-row>
                      <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									联系电话：
								</div>
								<div class="flex-1">
									{{data.mobile || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									身份证号：
								</div>
								<div class="flex-1">
									{{data.id_card || ''}}
								</div>
							 </div>
						  </el-col>
                      </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									地址：
								</div>
								<div class="flex-1">
									{{data.address || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									会员状态：
								</div>
								<div class="flex-1">
									<el-tag v-if="data.status === 1" size="mini" type="success">正常</el-tag>
									<el-tag v-if="data.status === 2" size="mini" type="danger">停用</el-tag>
									<el-tag v-if="data.status === 3" size="mini" type="warning">待审核</el-tag>
									<el-tag v-if="data.status === 4" size="mini" type="danger">驳回</el-tag>
								</div>
							 </div>
						  </el-col>
					  </el-row>
                      <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									分红类型：
								</div>
								<div class="flex-1">
									{{data.fh_type_txt || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							 <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									门店类型：
								</div>
								<div class="flex-1">
									{{data.store_type_txt || ''}}
								</div>
							 </div>
						  </el-col>
                      </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									入驻类型：
								</div>
								<div class="flex-1">
									<span v-if="data.fh_type == 1">线上</span>
									<span v-else-if="data.fh_type == 2">线下</span>
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									门店图片：
								</div>
								<div class="flex-1">
									<img :src="data.avatar" style="width: 80px;height: 80px;" @click="viewImage(data,'avatar')" v-if="data.avatar">
									<img src="@/assets/images/empty.png" style="width: 80px;height: 80px;" v-else>
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									营业执照：
								</div>
								<div class="flex-1">
									<img :src="data.yyzz" style="width: 80px;height: 80px;" @click="viewImage(data,'yyzz')" v-if="data.yyzz">
									<img src="@/assets/images/empty.png" style="width: 80px;height: 80px;" v-else>
								</div>
							  </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									身份证正面：
								</div>
								<div class="flex-1">
									<img :src="data.sfz_zm" style="width: 80px;height: 80px;" @click="viewImage(data,'sfz_zm')" v-if="data.sfz_zm">
									<img src="@/assets/images/empty.png" style="width: 80px;height: 80px;" v-else>
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									身份证反面：
								</div>
								<div class="flex-1">
									<img :src="data.sfz_fm" style="width: 80px;height: 80px;" @click="viewImage(data,'sfz_fm')" v-if="data.sfz_fm">
									<img src="@/assets/images/empty.png" style="width: 80px;height: 80px;" v-else>
								</div>
							  </div>
						  </el-col>
					  </el-row>
					  <el-row class="w-100 flex align-center mb-2">
						  <el-col :span="12">
							  <div class="w-100 flex align-center">
								<div class="flex align-center opacity-60" style="width: 100px;">
									注册时间：
								</div>
								<div class="flex-1">
									{{data.ctime || ''}}
								</div>
							  </div>
						  </el-col>
						  <el-col :span="12">
							  
						  </el-col>
					  </el-row>
		          </div>
		        </el-card>
		      </el-col>
		</el-row>
	</div>
</template>

<script>
	import common from "@/common/mixins/common.js"
	import Breadcrumb from '@/components/Breadcrumb';
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			Breadcrumb
		},
		data() {
			return {
				preUrl: 'store',
				autoRequest: false,
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				id:'',
				data:{},
			}
		},
		mounted() {
			if(this.$route.query.id){
				this.id = this.$route.query.id
				this.getDetail()
			}
		},
		methods:{
			getDetail() {
			  this.axios.get(`/manage/${this.preUrl}/detail`, {
			    params: {
					id:this.id
				}
			  }).then(res => {
			    this.data = res.data
			  })
			},
		}
	}
</script>

<style>
</style>